/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
    {
        url: "/dashboard",
        name: "Trang chủ",
        slug: "dashboard",
        icon: "HomeIcon",
        i18n: "Trang chủ",
        rule: 'organization_user',
        prefix: '/user/menu-dashboard'
    },
    {
        header: "Super Admin",
        icon: "PackageIcon",
        i18n: "Super Admin",
        rule: 'admin',
        items: [
            {
                url: "/admin/manage-organization",
                name: "Organization",
                slug: "manage-organization",
                icon: "GlobeIcon",
                i18n: "navMenu.organization",
            },
            {
                url: "/admin/manage-camera",
                name: "Camera",
                slug: "admin-manage-camera",
                icon: "CameraIcon",
                // i18n: "Organization",
            },
            // {
            //   url: "/admin/manage-master-work-shift",
            //   name: "Ca làm việc",
            //   slug: "manage-master-work-shift",
            //   icon: "GlobeIcon",
            //   rule: 'organization',
            //   i18n: "Organization",
            // },
            {
                url: null,
                name: 'navMenu.servicePack',
                i18n: 'Manage',
                icon: 'PackageIcon',
                rule: 'admin',
                submenu: [
                    {
                        url: "/admin/permission-function",
                        name: "navMenu.funcAuthority",
                        slug: "permission-function",
                        icon: "SidebarIcon",
                        i18n: "navMenu.funcAuthority",
                    },
                    {
                        url: "/admin/organization-package",
                        name: "navMenu.servicePack",
                        slug: "organization-package",
                        icon: "PackageIcon",
                        i18n: "navMenu.servicePack",
                    },
                    {
                        url: "/admin/history-register-package",
                        name: "navMenu.requestHistory",
                        slug: "history-register-package",
                        icon: "PackageIcon",
                        i18n: "navMenu.requestHistory",
                    },
                ]
            },
            // {
            //     url: null,
            //     name: 'Gói dịch vụ',
            //     i18n: 'Manage',
            //     icon: 'PackageIcon',
            //     rule: 'organization',
            //     submenu: [
            //         {
            //             url: "/user/register-organization-package",
            //             name: "Đăng ký gói dịch vụ",
            //             slug: "user-register-organization-package",
            //             i18n: "Organization",
            //         },
            //         {
            //             url: "/user/organization-package",
            //             name: "Gói dịch vụ",
            //             slug: "user-organization-package",
            //             i18n: "Organization",
            //         },
            //         {
            //             url: "/user/history-register-organization-package",
            //             name: "Lịch sử yêu cầu",
            //             slug: "user-register-organization-package",
            //             i18n: "Organization",
            //         },
            //     ]
            // },
            {
                url: null,
                name: 'navMenu.manageEmployee',
                i18n: 'navMenu.manageEmployee',
                icon: 'UsersIcon',
                rule: 'organization_user',
                prefix: '/user/menu-manager-employee',
                submenu: [
                    {
                        url: "/user/organization-info",
                        name: "navMenu.organizationInformation",
                        slug: "user-organization-info",
                        icon: "GlobeIcon",
                        i18n: "navMenu.organizationInformation",
                    },
                    {
                        url: "/apps/email",
                        name: "License",
                        slug: "license",
                        icon: "CreditCardIcon",
                        // i18n: "License",
                    },
                    {
                        url: "/user/organization-branch",
                        name: "navMenu.branch",
                        slug: "user-organization-branch",
                        icon: "GitBranchIcon",
                        i18n: "navMenu.branch",
                    },
                    {
                        url: "/user/manage-department",
                        name: "navMenu.department",
                        slug: "user-manage-department",
                        icon: "GitBranchIcon",
                        i18n: "navMenu.department",
                    },
                    {
                        url: "/user/manage-school",
                        name: "navMenu.school",
                        slug: "user-manage-school",
                        icon: "GitBranchIcon",
                        i18n: "navMenu.school",
                    },
                    {
                        url: "/user/manage-employee",
                        name: "navMenu.personnel",
                        slug: "user-manage-employee",
                        icon: "UsersIcon",
                        i18n: "navMenu.personnel",
                    },
                    {
                        url: "/user/manage-class",
                        name: "navMenu.class",
                        slug: "user-manage-class",
                        icon: "UsersIcon",
                        i18n: "navMenu.class",
                        prefix: '/user/teacher'
                    },
                    {
                        url: "/user/student",
                        name: "navMenu.student",
                        slug: "user-student",
                        icon: "UsersIcon",
                        i18n: "navMenu.student",
                    },
                    {
                        url: "/user/manage-permission",
                        name: "Quản lý quyền",
                        slug: "user-manage-permission",
                        icon: "CalendarIcon",
                        i18n: "navMenu.managePermission",
                    },
                    {
                        url: "/user/manage-position",
                        name: "Quản lý chức vụ",
                        slug: "user-manage-position",
                        icon: "CalendarIcon",
                        i18n: "navMenu.managePosition",
                    },
                    {
                        url: "/user/application-for-leave",
                        name: "Đơn xin nghỉ học sinh",
                        slug: "user-application-for-leave",
                        icon: "CalendarIcon",
                        i18n: "navMenu.studentLeaveApplication",
                    }

                    // {
                    //     url: "/user/manage-leave",
                    //     name: "navMenu.leave",
                    //     slug: "user-manage-leave",
                    //     icon: "CalendarIcon",
                    //     i18n: "navMenu.leave",
                    // }
                    // {
                    //   url: "/user/manage-stranger",
                    //   name: "Phát hiện xâm nhập",
                    //   slug: "manage-report-stranger",
                    //   icon: "FlagIcon",
                    //   i18n: "Report",
                    // },
                    // {
                    //   url: "/user/manage-crowded",
                    //   name: "Cảnh báo tụ tập",
                    //   slug: "manage-report-crowded",
                    //   icon: "AlertTriangleIcon",
                    //   i18n: "Report",
                    // },
                    // {
                    //   url: "/user/manage-face-id",
                    //   name: "Chấm công Face ID",
                    //   slug: "user-manage-face-id",
                    //   icon: "SmileIcon",
                    //   i18n: "FaceId",
                    // },
                ]
            },
            // {
            //     url: null,
            //     name: 'navMenu.customerManagement',
            //     i18n: 'navMenu.customerManagement',
            //     icon: 'UserPlusIcon',
            //     rule: 'organization',
            //     submenu: [
            //         {
            //             url: "/user/customer",
            //             name: "navMenu.customer",
            //             slug: "user-customer",
            //             icon: "UserMinusIcon",
            //             i18n: "navMenu.customer",
            //         },
            //         {
            //             url: "/user/in-out-history-customer",
            //             name: "navMenu.historyInOut",
            //             slug: "user-in-out-history-customer",
            //             icon: "SidebarIcon",
            //             i18n: "navMenu.historyInOut",
            //         },
            //         {
            //             url: "/user/in-out-history-customer-realtime",
            //             name: "navMenu.customerInOut",
            //             slug: "user-in-out-history-customer-realtime",
            //             icon: "SidebarIcon",
            //             i18n: "navMenu.customerInOut",
            //         }]
            // },
            // {
            //     url: null,
            //     name: 'navMenu.resourceManagement',
            //     i18n: 'navMenu.resourceManagement',
            //     icon: 'TrelloIcon',
            //     rule: 'organization',
            //     submenu: [{
            //         url: "/user/manage-multipurpose-room",
            //         name: "navMenu.functionRoom",
            //         slug: "user-manage-manage-multipurpose-room",
            //         icon: "EyeIcon",
            //         i18n: "navMenu.functionRoom",
            //     }]
            // },
            // {
            //     url: null,
            //     name: 'navMenu.manageCamera',
            //     i18n: 'navMenu.manageCamera',
            //     icon: 'CameraIcon',
            //     rule: 'organization',
            //     submenu: [
            //         {
            //             url: "/user/stream-camera",
            //             name: "navMenu.stream",
            //             slug: "stream-camera",
            //             icon: "EyeIcon",
            //             i18n: "navMenu.stream",
            //         },
            //         {
            //             url: "/user/play-back",
            //             name: "navMenu.playBack",
            //             slug: "license",
            //             icon: "FilmIcon",
            //             i18n: "navMenu.playBack",
            //         },
            //         // {
            //         //     url: "/user/manage-camera",
            //         //     name: "Camera",
            //         //     slug: "user-manage-camera",
            //         //     icon: "CameraIcon",
            //         //     i18n: "License",
            //         // },
            //         {
            //             url: "/user/manage-camera-layout",
            //             name: "navMenu.listCameras",
            //             slug: "user-manage-camera-layout",
            //             icon: "VideoIcon",
            //             i18n: "navMenu.listCameras",
            //         },
            //         {
            //             url: "/user/manage-camera-group",
            //             name: "navMenu.groupCamera",
            //             slug: "user-manage-camera-group",
            //             icon: "SettingsIcon",
            //             i18n: "navMenu.groupCamera",
            //         },
            //         {
            //             url: "/user/manage-event",
            //             name: "navMenu.event",
            //             slug: "user-manage-event",
            //             icon: "ClockIcon",
            //             i18n: "navMenu.event",
            //         },
            //     ]
            // },

            // {
            //     url: null,
            //     name: 'navMenu.intelligentHandling',
            //     i18n: 'navMenu.intelligentHandling',
            //     icon: 'EyeIcon',
            //     rule: 'organization',
            //     submenu: [
            //         {
            //             url: "/user/face-recognition",
            //             name: "navMenu.faceRecognition",
            //             slug: "face-recognition",
            //             icon: "SmileIcon",
            //             i18n: "navMenu.faceRecognition",
            //         },
            //         // {
            //         //     url: '/user/face-recognition-register',
            //         //     name: "Danh sách đăng kí",
            //         //     slug: "face-recognition-register",
            //         //     icon: "ListIcon",
            //         //     i18n: "License",
            //         // },
            //         {
            //             url: "/user/ai-restrictedarea",
            //             name: "navMenu.intrusionDetection",
            //             slug: "ai-restrictedarea",
            //             icon: "ListIcon",
            //             i18n: "navMenu.intrusionDetection",
            //             submenu: [
            //                 {
            //                     url: "/user/ai-restrictedarea",
            //                     name: "navMenu.intrusiveSettings",
            //                     slug: "ai-restrictedarea",

            //                     i18n: "navMenu.intrusiveSettings",
            //                 },
            //                 {
            //                     url: "/user/ai-restrictedarea-history",
            //                     name: "navMenu.infiltrationHistory",
            //                     slug: "ai-restrictedarea-history",

            //                     i18n: "navMenu.infiltrationHistory",
            //                 },
            //             ]
            //         },
            //     ]
            // },
            {
                url: "/user/schedule",
                name: "Thời khóa biểu",
                slug: "user-schedule",
                icon: "CalendarIcon",
                i18n: "Thời khóa biểu",
                rule: 'organization_user',
                prefix: '/user/menu-schedule'
            },
            {
                url: null,
                name: 'navMenu.attendance',
                icon: "ClipboardIcon",
                i18n: 'navMenu.attendance',
                rule: 'organization_user',
                prefix: '/user/menu-attendance',
                submenu: [
                    {
                        url: "/user/attendance",
                        name: 'navMenu.attendanceHistory',
                        slug: "user-attendance",
                        i18n: 'navMenu.attendanceHistory',
                        rule: 'organization',
                    },
                    {
                        url: "/user/student-in-out-history",
                        name: "navMenu.historyInOut",
                        slug: "user-srudent-in-out-history",
                        icon: "SidebarIcon",
                        i18n: "navMenu.historyInOut",
                    }
                ]
            },
            {
                url: null,
                name: 'navMenu.checkIn',
                i18n: 'navMenu.checkIn',
                icon: 'CheckCircleIcon',
                rule: 'organization_user',
                prefix: '/user/menu-manage-wifi',
                submenu: [
                    // {
                    //     url: "/user/manage-qr-code",
                    //     name: "navMenu.qrCheckIn",
                    //     slug: "user-manage-qr-code",
                    //     icon: "QRIcon",
                    //     i18n: "navMenu.qrCheckIn",
                    // },
                    // {
                    //     url: "/user/manage-work-shift-branch",
                    //     name: "navMenu.shift",
                    //     slug: "manage-branch-work-shift",
                    //     icon: "SettingsIcon",
                    //     i18n: "navMenu.shift",
                    // },
                    // {
                    //     url: "/user/manage-work-shift-by-day",
                    //     name: "navMenu.shiftDaybyday",
                    //     slug: "manage-work-shift-by-day",
                    //     icon: "ClockIcon",
                    //     i18n: "navMenu.shiftDaybyday",
                    // },
                    // {
                    //     url: "/user/over-time-manager",
                    //     name: "navMenu.workMore",
                    //     slug: "user-over-time-manager",
                    //     icon: "ClockIcon",
                    //     i18n: "navMenu.workMore",
                    // },
                    // {
                    //     url: "/user/manage-wifi",
                    //     name: "navMenu.wifiCheckIn",
                    //     slug: "user-manage-wifi",
                    //     icon: "WifiIcon",
                    //     i18n: "navMenu.wifiCheckIn",
                    // },
                    {
                        url: "/user/manage-work-shift-branch",
                        name: "navMenu.shift",
                        slug: "manage-work-shift-branch",
                        icon: "SidebarIcon",
                        i18n: "navMenu.shift",
                    },
                    {
                        url: "/user/time-keeping",
                        name: "navMenu.historyCheckIn",
                        slug: "time-keeping",
                        icon: "UserIcon",
                        i18n: "navMenu.historyCheckIn",
                    },
                    {
                        url: "/user/confirm-time-keeping",
                        name: "Xác nhận chấm công",
                        slug: "personnel",
                        icon: "ClipboardIcon",
                        // i18n: "Organization",
                    },
                    {
                        url: "/user/time-keeping-teacher",
                        name: "navMenu.historyCheckInTeacher",
                        slug: "time-keeping-teacher",
                        icon: "UserIcon",
                        i18n: "navMenu.historyCheckInTeacher",
                    },
                    // {
                    //     url: "/user/update-in-out",
                    //     name: "navMenu.complaintLetter",
                    //     slug: "update-in-out",
                    //     icon: "CalendarIcon",
                    //     i18n: "navMenu.complaintLetter",
                    // },
                    {
                        url: "/user/in-out-history",
                        name: "navMenu.historyInOut",
                        slug: "personnel",
                        icon: "SidebarIcon",
                        i18n: "navMenu.historyInOut",
                    },
                    {
                        url: "/user/manage-branch-work-shift",
                        name: "navMenu.shift",
                        slug: "personnel",
                        icon: "SidebarIcon",
                        i18n: "navMenu.shift",
                    }
                ]
            },
            {
                url: "/user/work-shift-school",
                name: "Ca làm việc",
                slug: "dashboard",
                icon: "ClockIcon",
                i18n: "Ca làm việc",
                prefix: '/user/menu-work-shift-school',
                rule: 'organization_user'
            },
            {
                url: "/user/schedule-staff",
                name: "Lịch làm việc nhân viên",
                slug: "user-schedule-staff",
                icon: "CalendarIcon",
                i18n: "Lịch làm việc nhân viên",
                prefix: '/user/schedule-staff',
                rule: 'organization_user'
            },
            {
                url: null,
                name: 'navMenu.manageNew',
                i18n: 'navMenu.manageNew',
                icon: 'NavigationIcon',
                rule: 'organization_user',
                prefix: '/user/menu-internal-communications',
                submenu: [
                    {
                        url: "/user/manage-news",
                        name: "navMenu.mNew",
                        slug: "user-manage-news",
                        icon: "BriefcaseIcon",
                        i18n: "navMenu.mNew",
                    },
                    {
                        url: "/user/manage-notification",
                        name: "navMenu.notification",
                        slug: "user-manage-notification",
                        icon: "GiftIcon",
                        i18n: "navMenu.notification",
                    },
                    {
                        url: "/user/manage-classroom-manager",
                        name: "navMenu.classroomManager",
                        slug: "user-manage-classroom-manager",
                        icon: "BriefcaseIcon",
                        i18n: "navMenu.classroomManager",
                    },
                ]
            },

            {
                url: null,
                name: 'navMenu.manageDevice',
                i18n: 'navMenu.manageDevice',
                icon: 'PackageIcon',
                rule: 'organization_user',
                prefix: '/user/menu-asset',
                submenu: [
                    {
                        url: "/user/manage-device",
                        name: "navMenu.listDevice",
                        slug: "manage-device",
                        icon: "BriefcaseIcon",
                        i18n: "navMenu.listDevice",
                    },
                    {
                        url: "/user/assign-device-history",
                        name: "navMenu.historyDevice",
                        slug: "assign-device-history",
                        icon: "ClockIcon",
                        i18n: "navMenu.historyDevice",
                    },
                ]
            },

            {
                url: null,
                name: 'navMenu.manageEquipment',
                i18n: 'navMenu.manageEquipment',
                icon: 'ArchiveIcon',
                rule: 'organization_user',
                prefix: '/user/menu-item',
                submenu: [
                    {
                        url: "/user/manage-equipment",
                        name: "navMenu.listEquipment",
                        slug: "manage-equipment",
                        icon: "BriefcaseIcon",
                        i18n: "navMenu.listEquipment",
                    },
                    {
                        url: "/user/edit-equipmen",
                        name: "navMenu.editEquipment",
                        slug: "manage-equipment",
                        icon: "GiftIcon",
                        i18n: "navMenu.editEquipment",
                    },

                    {
                        url: "/user/assign-equipment-history",
                        name: "navMenu.historyEquipment",
                        slug: "assign-equipment-history",
                        icon: "ClockIcon",
                        i18n: "navMenu.historyEquipment",
                    },
                ]
            },

            //Library
            {
                url: null,
                name: 'navMenu.library',
                i18n: 'navMenu.library',
                icon: 'BookIcon',
                rule: 'organization_user',
                prefix: '/user/menu-library',
                submenu: [
                    {
                        url: "/user/manage-category",
                        name: "navMenu.category",
                        slug: "manage-category",
                        i18n: "navMenu.category",
                    },
                    {
                        url: "/user/manage-book",
                        name: "navMenu.book",
                        slug: "manage-book",
                        i18n: "navMenu.book",
                    },
                ]
            },

            //Document
            {
                url: "/user/document",
                name: "Tài liệu nội bộ",
                slug: "document",
                icon: "LayersIcon",
                i18n: "Tài liệu nội bộ",
                prefix: '/user/menu-document',
                rule: 'organization_user'
            },

            //Invoice
            {
                url: null,
                name: 'navMenu.invoice',
                i18n: 'navMenu.invoice',
                icon: 'FileMinusIcon',
                rule: 'organization_user',
                prefix: '/user/menu-invoice',
                submenu: [
                    {
                        url: "/user/manage-receipts",
                        name: "navMenu.receipts",
                        slug: "manage-receipts",
                        i18n: "navMenu.receipts",
                    },
                    {
                        url: "/user/manage-payroll",
                        name: "navMenu.teacherSalarySchedule",
                        slug: "manage-payroll",
                        i18n: "navMenu.teacherSalarySchedule",
                    },
                ]
            },

            {
                url: "/user/teacher-interaction",
                name: "Bài tập - Đánh giá",
                slug: "user-teacher-interaction",
                icon: "BookOpenIcon",
                i18n: "Bài tập - Đánh giá",
                prefix: '/user/menu-teacher-interaction',
                rule: 'organization_user'
            },
            //Giao bài tập
            {
                url: null,
                name: 'navMenu.exercises',
                i18n: 'navMenu.exercises',
                icon: 'FileTextIcon',
                rule: 'organization_user',
                prefix: '/user/menu-exam',
                submenu: [
                    {
                        url: "/user/multiple-category",
                        name: "navMenu.category",
                        slug: "multiple-category",
                        i18n: "navMenu.category",
                    },
                    {
                        url: "/user/multiple-topic-set",
                        name: "navMenu.questions",
                        slug: "multiple-topic-set",
                        i18n: "navMenu.questions",
                    },
                    {
                        url: "/user/multiple-choice-exercises",
                        name: "navMenu.multipleChoiceExercises",
                        slug: "multiple-choice-exercises",
                        i18n: "navMenu.multipleChoiceExercises",
                    },
                    {
                        url: "/user/multiple-choice-exercises-history",
                        name: "navMenu.assignmentHistory",
                        slug: "multiple-choice-exercises-history",
                        i18n: "navMenu.assignmentHistory",
                    },
                    {
                        url: "/user/student-work-history",
                        name: "navMenu.studentWorkHistory",
                        slug: "student-work-history",
                        i18n: "navMenu.studentWorkHistory",
                    }
                ]
            },
            //BADGES
            {
                url: null,
                name: 'Huy hiệu',
                i18n: 'navMenu.badges',
                icon: 'AwardIcon',
                rule: 'organization_user',
                prefix: '/config/menu-exam',
                submenu: [
                    {
                        url: "/user/badges",
                        name: "navMenu.badges",
                        slug: "user-badges",
                        i18n: "navMenu.badges",
                    },
                ]
            },
            //CONFIG
            {
                url: null,
                name: 'Cấu hình',
                i18n: 'navMenu.config',
                icon: 'SettingsIcon',
                rule: 'organization_user',
                prefix: '/config/menu-exam',
                submenu: [
                    {
                        url: "/config/classtime",
                        name: "navMenu.classTime",
                        slug: "classtime-category",
                        i18n: "navMenu.classTime",
                    },
                ]
            }
        ]
    },
]
